<template>
  <div>
    <Card>
      <template #title>Roles</template>
      <template #content>
        <DataTable
          class="p-datatable-sm"
          :paginator="true"
          :rows="5"
          stripedRows
          :loading="loading"
          :value="rolesList"
          dataKey="id"
          :filters.sync="filtros"
          :globalFilterFields="['nome']"
          filterDisplay="menu"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} vínculos"
          responsiveLayout="scroll">
          <template #empty> Nenhuma role encontrada. </template>
          <template #loading> Carregando. Por favor aguarde. </template>
          <template #header>
            <span class="mt-2 mr-2 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filtros['global'].value"
                placeholder="Pesquisar"
                style="width: 100%" />
            </span>
            <Button
              icon="pi pi-filter-slash"
              label="Limpar"
              class="mt-2 mr-2 p-button-outlined"
              @click="limparFiltro" />
            <Button
              label="Nova Role"
              icon="pi pi-plus"
              class="mt-2 mr-2 p-button-submit float-right"
              @click="showFormDialog()" />
          </template>
          <Column field="nome" header="Nome"></Column>
          <Column header="Ações">
            <template #body="slotProps">
              <Button
                v-tooltip.left="'Editar'"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-warning mr-2"
                @click="showFormDialog(slotProps.data)" />
              <Button
                v-tooltip.left="'Remover'"
                class="p-button-danger p-button-rounded mt-2"
                icon="pi pi-trash"
                @click="removerRole(slotProps.data)" />
            </template>
          </Column>
        </DataTable>
      </template>
    </Card>
    <RoleFormDialog
      :visible.sync="showRoleFormDialog"
      :update="update"
      :propsrole="role" />
  </div>
</template>
<script>
import { FilterMatchMode, FilterOperator } from 'primevue/api/'
import { watch } from 'vue-demi'
import RoleFormDialog from './RoleFormDialog.vue'
import RoleService from '@/service/RoleService'
export default {
  components: {
    RoleFormDialog,
  },
  data() {
    return {
      loading: false,
      rolesList: [],
      filtros: {},
      showRoleFormDialog: false,
      update: false,
      role: {},
    }
  },

  created() {
    this.roleService = new RoleService(this.$http)
    this.initFiltros()
    watch(
      () => this.showRoleFormDialog,
      () => {
        if (!this.showRoleFormDialog) {
          this.carregarRoles()
        }
      },
    )
  },

  mounted() {
    this.carregarRoles()
  },

  methods: {
    limparFiltro() {
      this.initFiltros()
    },

    initFiltros() {
      this.filtros = {
        global: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.CONTAINS },
            { value: null, matchMode: FilterMatchMode.EQUALS },
          ],
        },
      }
    },

    carregarRoles() {
      this.roleService
        .getAll()
        .then((res) => {
          this.rolesList = res
        })
        .catch((err) => {
          this.exibirToastError(err)
        })
    },

    showFormDialog(data) {
      if (data) {
        this.role = data
        this.update = true
      } else {
        this.role = {}
        this.update = false
      }
      this.showRoleFormDialog = true
    },

    removerRole(data) {
      this.roleService
        .delete(data.id)
        .then(() => {
          this.carregarRoles()
          this.exibirToastSuccess('Role removida com sucesso!')
        })
        .catch((err) => {
          this.exibirToastError(err)
        })
    },

    exibirToastError(err) {
      this.$toast.add({
        severity: 'error',
        summary: err.response.data.message,
        life: 10000,
      })
    },

    exibirToastSuccess(message) {
      this.$toast.add({
        severity: 'success',
        summary: message,
        life: 10000,
      })
    },
  },
}
</script>
<style></style>
